<template>
	<div class="catchment-store-header d-flex flex-column align-center">
		<v-chip v-if="isReference" size="x-small" color="error" variant="flat" class="catchment-store-header__tag" readonly>{{ t('Visited') }}</v-chip>
		<div class="catchment-store-header__identity">
			<v-avatar size="24" :color="logoUrl ? 'white' : badgeColor" class="catchment-store-header__badge">
				<v-img v-if="logoUrl" :src="logoUrl" alt="" />
				<span v-else class="catchment-store-header__badge-letter">{{ badgeLetter }}</span>
			</v-avatar>
			<span class="catchment-store-header__name">{{ store.label }}</span>
		</div>
		<span v-if="subtitle" class="catchment-store-header__subtitle">{{ subtitle }}</span>
	</div>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import { getAccountImageUrl } from '@/api/core/file.js';

const t = useTranslator();

const props = defineProps({
	params: { type: Object, required: true },
});

const store = computed(() => props.params?.store || {});
const isReference = computed(() => Boolean(props.params?.isReference));
const badgeColor = computed(() => props.params?.badgeColor || 'primary');
const badgeLetter = computed(() => props.params?.badgeLetter || '');
const subtitle = computed(() => [store.value.channel, store.value.posType].filter(Boolean).join(' · '));

const accountImageUid = computed(() => props.params?.accountImageUid || null);
const logoUrl = ref(null);
watchEffect(async () => {
	const uid = accountImageUid.value;
	logoUrl.value = uid ? await getAccountImageUrl(uid) : null;
});
</script>

<style lang="scss">
@use '@/styles/variables' as *;

.catchment-store-header {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 4px 0;
	width: 100%;
	white-space: normal;

	&__tag {
		font-size: $font-size-tiny;
		height: 18px;
	}

	&__identity {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
	}

	&__badge-letter {
		font-size: $font-size-small;
		font-weight: 600;
		color: white;
	}

	&__name {
		font-size: $font-size-small;
		font-weight: 600;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	&__subtitle {
		font-size: $font-size-tiny;
		color: rgba(var(--v-theme-on-surface), 0.6);
	}
}
</style>
